import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { Layout } from "./components/Layout.tsx";
import { Seo } from "./components/Seo.tsx";
import { Connect } from "./pages/Connect.tsx";
import { FAQ } from "./pages/FAQ.tsx";
import { Gallery } from "./pages/Gallery.tsx";
import { Home } from "./pages/Home.tsx";
import { Pricing } from "./pages/Pricing.tsx";
import { Services } from "./pages/Services.tsx";

export default function App() {
  return (
    <Router>
      <Seo />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/connect" element={<Connect />} />
        </Routes>
      </Layout>
      <Analytics />
    </Router>
  );
}
